import { apiClient } from "./apiClient";
const BASE_PATH = "/api/v1/validation-rules";
/**
 * Get all validation rules with optional filtering
 */
export const getValidationRules = async (params) => {
    const response = await apiClient.get(BASE_PATH, { params });
    // Backend returns { data: rules[] }, but we want { rules: rules[] }
    return { rules: response.data.data };
};
/**
 * Get a single validation rule by ID
 */
export const getValidationRule = async (id) => {
    const response = await apiClient.get(`${BASE_PATH}/${id}`);
    return response.data;
};
/**
 * Create a new validation rule
 */
export const createValidationRule = async (data) => {
    const response = await apiClient.post(BASE_PATH, data);
    return response.data;
};
/**
 * Update an existing validation rule
 */
export const updateValidationRule = async (id, data) => {
    const response = await apiClient.put(`${BASE_PATH}/${id}`, data);
    return response.data;
};
/**
 * Delete a validation rule
 */
export const deleteValidationRule = async (id) => {
    await apiClient.delete(`${BASE_PATH}/${id}`);
};
/**
 * Duplicate a validation rule
 */
export const duplicateValidationRule = async (id, name) => {
    const response = await apiClient.post(`${BASE_PATH}/${id}/duplicate`, { name });
    return response.data;
};
/**
 * Reorder validation rules
 */
export const reorderValidationRules = async (ruleIds) => {
    await apiClient.post(`${BASE_PATH}/reorder`, { ruleIds });
};
/**
 * Test a validation rule against sample data
 */
export const testValidationRule = async (data) => {
    // Convert to backend expected format
    const payload = {
        rule: {
            conditions: data.conditions,
            requirements: data.requirements
        },
        testData: data.sampleData
    };
    const response = await apiClient.post(`${BASE_PATH}/test`, payload);
    return response.data.data;
};
